// extracted by mini-css-extract-plugin
export default {"imageWrapper":"JL-z","twoColumnImage":"KL-z"};